import { useTranslation } from 'react-i18next';

import { AlertDetailRecord, AlertHeader } from '@/modules/home';
import { IHome } from '@/modules/home/types';
import { Avatar, NextImage } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Clipboard from '~/images/shared/clipboard-text.svg';
import NoteIcon from '~/images/shared/document-text.svg';
import Dollar from '~/images/shared/dollar-circle.svg';
import Warning from '~/images/shared/warning.svg';
import Worker from '~/images/shared/Worker.svg';

const TimelineAlert: React.FC<{
  alert: IHome.ITimelineAlertItem;
}> = ({ alert }) => {
  const { t } = useTranslation();
  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <div className='flex  gap-12 px-16'>
      <div className='shrink-0'>
        <Avatar
          className='  bg-error-95'
          size='sm'
          icon={<Warning className='text-18' />}
        />
      </div>
      <div className='flex flex-grow flex-col gap-12'>
        {/* Alert name and Reporter */}
        <AlertHeader alert={alert} />
        <div className='h-px w-full bg-grey-200 bg-opacity-5' />
        {/* ************************* Alert Details  **************************** */}
        <div className='flex flex-col gap-8'>
          <AlertDetailRecord
            label={t('input-method')}
            value={t(
              alert.deductionType === 0
                ? t('Amount')
                : alert.deductionType === 2
                ? t('value-per-unit')
                : t('Fraction of units')
            )}
            Icon={<Clipboard />}
          />
          {/* TODO: check again */}
          <div className='flex gap-30'>
            <AlertDetailRecord
              label={t('deduction-value')}
              value={`${
                alert.deductionType === 1
                  ? String(alert.fractionOfUnits)
                  : alert.deductionType === 2
                  ? String(alert.pricePerUnit)
                  : String(alert.amount)
              } ${
                alert.deductionType === 2
                  ? `${selectedAsset?.currency}/${alert.measurementUnit}`
                  : alert.deductionType === 0
                  ? selectedAsset?.currency
                  : alert.pricingMethod === 0
                  ? t('daily')
                  : alert.measurementUnit
              } `}
              Icon={<Dollar />}
            />
            <AlertDetailRecord
              label={t('caused-by')}
              value={alert.workerName}
              Icon={<Worker />}
            />
          </div>
        </div>
        <div className='h-px w-full bg-grey-200 bg-opacity-5' />
        {/* ************************* Alert note  **************************** */}
        <AlertDetailRecord
          label={t('note')}
          value={alert.note ?? '-'}
          Icon={<NoteIcon />}
        />
        {/* TODO: dots */}
        {alert.attachment && (
          <div className='overflow-hidden rounded-lg'>
            <NextImage src={alert.attachment} alt='' height={100} width={120} />
          </div>
        )}
      </div>
    </div>
  );
};
export { TimelineAlert };
